import React, { Component } from 'react'
import { connect } from 'react-redux'
import { autobind } from 'react-decoration'
import moment from 'moment'
import url from 'url'
import SideBar from '@components/sideBar'
import TabSwitcher from '@components/tabSwitcher'
import { Text, Article } from '@components/note'
import { Button, Field } from '@components/input'
// import SearchBar from '@components/searchBar'

import { actions } from 'mindself-api-client'
const { ContentActions, HTTPClientActions, UserActions } = actions

// const tabs = ['For You', 'Short Minds', 'All Saved Minds']
const tabs = ['Short Minds', 'All Saved Minds']

const textProps = {
  component: 'Text',
  content:
    'Today, the freeCodeCamp community turns 1,000 days old. We’ve accomplished a lot together in that time:',
  title: 'How we’re using Component Based Design',
  time: '18 hours age',
  type: 'Note',
}

const MidContent = props => {
  const { selectedNotes, onSelectNote, notes } = props
  return (
    <div>
      <div className="minds">Minds</div>
      <TabSwitcher tabs={tabs} defaultTab={0} />
      <div className="scrollable">
        <div className="small-text">Recently Added</div>
        <div className="contents">
          {Array.from({ length: 2 }).map((_, contentColIdx) =>
            notes
              .filter((_, idx) => idx % 2 === contentColIdx)
              .map((note, idx) => {
                const Note = note.component === 'Text' ? Text : Article
                const realIdx = idx * 2 + contentColIdx
                return (
                  <div className="content">
                    <Note
                      {...note}
                      key={idx}
                      selected={selectedNotes[realIdx]}
                      onCheckClick={() => onSelectNote(realIdx)}
                    />
                  </div>
                )
              })
          )}
        </div>
      </div>
      <style jsx>{`
        .minds {
          color: #333333;
          font-size: 24px;
          margin-bottom: 40px;
        }
        .scrollable {
          height: calc(100vh - 183px);
          overflow: scroll;
        }
        .small-text {
          margin: 40px 0 16px;
          color: #707070;
          font-weight: 500;
          font-size: 14px;
        }
        .contents {
          display: flex;
          flex-wrap: wrap;
        }
        @media screen and (min-width: 1600px) {
          .content {
            width: 33%;
          }
        }
        @media screen and (min-width: 1280px) and (max-width: 1599px) {
          .content {
            width: 50%;
          }
        }
        @media screen and (max-width: 1279px) {
          .content {
            width: 100%;
          }
        }
      `}</style>
    </div>
  )
}

const RightContent = ({ onAddBtnClick }) => {
  return (
    <div className="right-content">
      <div className="input">
        <Field
          placeholder="Type idea or URL link …"
          onAddBtnClick={onAddBtnClick}
        />
      </div>
      {/* <div className="input">
        <Button primary text="Add Note" />
      </div> */}
      {/* <div className="input">
        <Button text="Upload Photos" />
      </div> */}
      <style jsx>{`
        .right-content {
          padding: 152px 32px 0 8px;
        }
        .input + .input {
          margin-top: 8px;
        }
      `}</style>
    </div>
  )
}

@connect(null, { ...ContentActions, ...HTTPClientActions, ...UserActions })
class HomePage extends Component {
  state = {
    selectedNotes: [],
    notes: [],
  }
  @autobind
  handleNoteSelect(idx) {
    this.setState(prevState => {
      const newSelectedNotes = prevState.selectedNotes.slice()
      newSelectedNotes[idx] = !newSelectedNotes[idx]
      return {
        selectedNotes: newSelectedNotes,
      }
    })
  }

  @autobind
  async loadNotes() {
    const { listContent } = this.props
    const listContentRes = await listContent({
      fields: 'userId,contentId,tags,mTime,starTime,class,type,title,origin',
      limit: 1e3,
    })
    const contents = listContentRes.result
    this.setState(() => ({
      notes: contents.map((content, idx) => ({
        component: 'Article',
        imgSrc: `http://lorempixel.com/400/200/people/${content.mTime % 10 +
          1}/`,
        title: content.title,
        time: moment(content.mTime * 1000).fromNow(),
        type: url.parse(content.origin.split('url:')[1]).hostname,
        onNoteClick: () => {
          // const contentId = content.contentId
          // this.props.router.push(`/content?id=${contentId}`)
          const win = window.open(content.origin.split('url:')[1], '_blank')
          win.focus()
        },
      })),
    }))
  }

  @autobind
  async handleCreateUrlClick(url) {
    const { createURL } = this.props
    // get current url and create
    const createURLRes = await createURL({ body: url })
    await this.loadNotes()
  }

  async componentDidMount() {
    const { isLogin, setAuthorizationInfo } = this.props

    const isLoginRes = await isLogin()
    const userId = isLoginRes.result
    setAuthorizationInfo(userId)

    await this.loadNotes()
  }
  render() {
    const { notes } = this.state
    return (
      <div>
        <div className="grid">
          {/* <div className="search-bar">
            <SearchBar />
          </div> */}
          <div className="col-lg-2 gut-lg-2 col-bg-2 gut-bg-3 col-md-3 gut-md-3 col-sm-3 gut-sm-4 col-xs-3 gut-xs-4">
            <div className="sidebar">
              <SideBar />
            </div>
          </div>
          <div className="mid col-lg-8 gut-lg-9 col-bg-8 gut-bg-7 col-md-6 gut-md-7 col-sm-7 gut-sm-6 col-xs-7 gut-xs-6">
            <MidContent
              selectedNotes={this.state.selectedNotes}
              onSelectNote={this.handleNoteSelect}
              notes={notes}
            />
          </div>
          <div className="col-lg-2 gut-lg-2 col-bg-2 gut-bg-3 col-md-3 gut-md-3 col-sm-2 gut-sm-3 col-xs-2 gut-xs-3">
            <RightContent onAddBtnClick={this.handleCreateUrlClick} />
          </div>
        </div>
        <style jsx>{`
          .search-bar {
            position: absolute;
            right: 90px;
            top: 48px;
          }
          .grid {
            display: flex;
            position: relative;
          }
          .mid {
            padding: 48px 40px 0;
            box-sizing: border-box;
          }
          .sidebar {
            height: 100vh;
          }
        `}</style>
      </div>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/pages/home.js